<div class="device-setup-initial-outer">
  <div class="device-setup-inital-split-panel">
    <div>
      <h1>
        Before you start
      </h1>
      <p>
        If you are starting your session for the first time we recommend going through the device setup steps to make sure your device is properly configured.
        <br /><br />
        If you are relaunching a session you may wish to skip this step and join your session directly.
      </p>
      <div>
        <button class="btn-main" type="button" (click)="setDeviceSetupStage1()">Device Setup</button>
        <button class="btn-main" type="button" (click)="redirectToSession()">Join Session</button>
      </div>
    </div>
  </div>
</div>
